import { Link } from 'react-router-dom';

export default function Demo() {
    return (
      <section id="demo" className="demo">
        <h2 className="section-title">See The Magic</h2>
        
        <div className="demo-container">
          <div className="demo-text">
            <h3 className="demo-title">Experience Living Portraits</h3>
            <p className="demo-description">WizardPortrait brings the magic of living paintings from the wizarding world into your home. When your TV is not in use, it transforms into an interactive portrait that&apos;s always ready to assist you.</p>
            
            <div className="demo-features">
              <div className="demo-feature">
                <div className="demo-feature-icon">✨</div>
                <p>A customizable personality with ChatGPT brain</p>
              </div>
              <div className="demo-feature">
                <div className="demo-feature-icon">✨</div>
                <p>Natural conversations with your portrait</p>
              </div>
              <div className="demo-feature">
                <div className="demo-feature-icon">✨</div>
                <p>Internet access to get the latest news and information</p>
              </div>
              <div className="demo-feature">
                <div className="demo-feature-icon">✨</div>
                <p>Continuous learning and adaptation </p>
              </div>
            </div>
            
            {/* <Link to="/demo" className="cta-button">Watch Full Demo</Link> */}
          </div>
          
          <div className="relative md:w-[525px] md:h-[300px] w-[310px] h-[175px]">
          <video className="   h-[175px] md:h-[300px]" src="/tv2.mp4" autoPlay muted loop />

              <img src="/framing.png" alt="tv" className="absolute top-0 left-0 w-[310px] h-[175px] z-10 md:w-[525px] md:h-[300px]" />
   
          </div>
        </div>
  
        <style jsx>{`
          .demo {
            background: radial-gradient(circle at 50% 50%, rgba(59, 51, 74, 0.2) 0%, rgba(21, 4, 51, 0) 70%);
            color: white;
            padding: 8rem 2rem;
            text-align: center;
          }
          
          .section-title {
            font-family: 'Cinzel Decorative', serif;
            font-size: 2rem;
            text-align: center;
            margin-bottom: 3rem;
            position: relative;
            display: inline-block;
            font-weight: 200;
            color: #A16207;
          }
          
          .section-title::after {
            content: '';
            position: absolute;
            width: 80px;
            height: 4px;
            background: #A16207;
            bottom: -15px;
            left: 50%;
            transform: translateX(-50%);
          }
          
          .demo-container {
            max-width: 1200px;
            margin: 4rem auto 0;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
            gap: 4rem;
            align-items: center;
          }
          
          .demo-text {
            text-align: left;
          }
          
          .demo-title {
            font-size: 2rem;
            margin-bottom: 1.5rem;
            color: #white;
            font-family: serif;
            font-weight: 200;
          }
          
          .demo-description {
            margin-bottom: 2rem;
            font-size: 1.1rem;
          }
          
          .demo-features {
            margin-bottom: 1rem;
          }
          
          .demo-feature {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;
            font-family: 'Montserrat', sans-serif;
            font-weight: 200;
            letter-spacing: 1px;
          }
          
          .demo-feature-icon {
            margin-right: 1rem;
            color: #A16207;
            font-size: 1.5rem;
          }
          
          .magic-tv {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            border: 1px solid #A16207;
          }
          
          .tv-frame {
            width: 100%;
            height: 100%;
            background: #000;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
            position: relative;
          }
          
          .tv-screen {
            position: absolute;
            top: 20px;
            left: 20px;
            right: 20px;
            bottom: 20px;
            background: #A16207;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .tv-portrait {
            width: 70%;
            height: 85%;
            border: 8px solid #A16207;
            position: relative;
            overflow: hidden;
            background: #3A2A5E;
          }
          
          .tv-person {
            position: absolute;
            width: 100%;
            height: 100%;
            background: url('/api/placeholder/300/400') center/cover;
            animation: tvPersonMove 10s infinite alternate ease-in-out;
          }
          
          .tv-controls {
            position: absolute;
            bottom: 15px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 10px;
          }
          
          .tv-button {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: #444;
          }
          
          .tv-button:nth-child(1) {
            background: var(--accent);
          }
          
          .cta-button {
            background: var(--accent);
            color: var(--text-dark);
            font-size: 1rem;
            font-weight: 600;
            padding: 0.8rem 1.8rem;
            border-radius: 50px;
            border: none;
            cursor: pointer;
            transition: var(--transition);
            text-transform: uppercase;
            letter-spacing: 1px;
            text-decoration: none;
            display: inline-block;
          }
          
          .cta-button:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 20px rgba(249, 185, 50, 0.3);
          }
          
          @media (max-width: 768px) {
            .demo-container {
              grid-template-columns: 1fr;
            }
          }
        `}</style>
      </section>
    );
  } 